export const VERSION = '10.0.11';
//# sourceMappingURL=pkg-version.js.map